//needed - run on initial page load
// done - scrolling event handling
// account for more than one product option
// make this work for all products, currently the form is hard coded to 1 product
//remove testing mode and turn into IIFE
//brand new comment

let queryString1 = window.location.search;
let urlParams1 = new URLSearchParams(queryString1);
let testing_mode = urlParams1.get('testing-mode');


//if(testing_mode || testing_mode == '1'){

console.log('running theme file on outlet', testing_mode);



let ATCButton = document.querySelector('[name="add"].addToCart');
let formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol'});
let elements_to_callbacks = [];
let all_swatches = Array.from ( document.querySelectorAll('img[data-variant-id].swatch') );
let variants = JSON.parse( document.querySelector('script#variant-data').text );
variants = variants.filter(variant => variant.available === true);//filter out the variants that are not available
let variant_groups = JSON.parse( document.querySelector('script#variant-groups').text );
let color_option_index = JSON.parse( document.querySelector('script#color-option-index').text ).color_option_index;
let ATCButtonText = ATCButton.querySelector('span');
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let initial_swatch = document.querySelector(`img[data-variant-id="${urlParams.get('variant')}"]`);
let color_groups = [];
let color_groups_display_order = ['favorites','brunettes','blondes','blacks','fashion-color','grays','greys','reds','new_colors','best_sellers',''];
let variant_selector = document.querySelector('select[name="options[Color]"]');
let variant_selector_wrapper = document.querySelector('variant-selects');
let getURLParams = (param='') =>{
  const queryString = window.location.search;
 
  const urlParams = new URLSearchParams(queryString);

  
  return urlParams.get(param);
}
let clearance_percent_messaging = [{percent_off:20,message:"CLEARANCE UP TO EXTRA 20% OFF",default:true},{percent_off:25,message: "CLEARANCE UP TO EXTRA 25% OFF"}];





['click','change','slideChanged'].forEach(event_type =>{


document.addEventListener(event_type,function(e){
    
    let elems = elements_to_callbacks.filter(elem => { if(e.target.matches( elem.element_selector)){ return elem }  });
    
    elems.forEach((el) => 
        {
          
            if(e.target.matches(el.element_selector) && event_type == el.event_type ) {
                try{
                    
                    el.callback(e.target,e)
                    
                }catch(error){
                    console.log(error);
                }
            }
        }
        );
    
        
});
    
});


function findVariantIDInGroups(variant_id){
        let group_name = null;
    let groups = Object.entries(variant_groups.datasets);

    let [group] = groups.filter(group => {

        let [group_name,variants] = group;
        return variants.includes(parseInt(variant_id));

        
    });
        if(group){

            [group_name] = group;    
        }
        
        
        return group_name;
}




function disableATCButton(){
      ATCButton.setAttribute('disabled',true);
    
    
   
}

function enableATCbutton(){

        ATCButton.removeAttribute('disabled');

}


function updateATCButtonText(target,event,message=null){
    
    if(message){

        setTimeout( function(){  ATCButtonText.textContent = message; },600);


    }else{

        
        let groups_to_messages = [];
        groups_to_messages['pre_launch'] = "Coming Soon";
        groups_to_messages['unavailable'] = "Sold out";
        

        let current_swatch = getCurrentSwatch(target);

        let variant_id = current_swatch.dataset.variantId;

        let group_name= findVariantIDInGroups(variant_id);

        if(Object.keys(groups_to_messages).includes(group_name)){
                
                if(groups_to_messages.hasOwnProperty(group_name)){
                    
                   setTimeout( function(){  ATCButtonText.textContent = groups_to_messages[group_name] ; },600);
                   
                }

        }else{
              
                   setTimeout( function(){  ATCButtonText.textContent = "Add to cart" ; },600);
                   
        }
        
        


    }
    
}

function getCurrentSwatch(target){
    let current_swatch;
    if( target.matches('img[data-variant-id]') ){
        current_swatch = document.querySelector(`[data-variant-id="${target.dataset.variantId}"]`);

    }
    else if(target.matches(`select[name="options[Color]"]`)){
    
    current_swatch_color = target.value;
    current_swatch_info = getVariantWith('color',current_swatch_color);
    current_swatch = document.querySelector(`[data-variant-id="${current_swatch_info.id}"]`);
    
    }

    return current_swatch;
}
function getVariantWith(type,search_for){
    

    
    let [find] = variants.filter(variant => {
        
        if(type=='variant_id'){
            return variant.id == search_for
        }else if(type=='color'){

                let title_parts = variant.title.split(' / ');
                return title_parts.includes(search_for);

        }
    });
    
        return find;
    }
    
function updateVariantParameter(variant_id){

var queryParams = new URLSearchParams(window.location.search);
queryParams.set("variant", variant_id.toString());
history.replaceState(null, null, "?"+queryParams.toString());

}

function updateSelector (target){
//console.log(target);
    let variant_id_to_find = target.dataset.variantId;
//    console.log(variant_id_to_find);
    
    let option_to_select = variants.filter(variant => variant.id == variant_id_to_find).map(variant => variant[color_option_index]);
    variant_selector.value=option_to_select;
    variant_selector_wrapper.dispatchEvent(new Event('change'));
    updateVariantParameter(variant_id_to_find);
    
}

function highlightCurrentSwatch(target){
    let current_swatch = getCurrentSwatch(target);
    
  

    
    Array.from( all_swatches ).forEach(x => { x.style.border = '1px solid transparent'; x.classList.remove('selected-swatch')});
    
    current_swatch.style.border = '1px solid #c41949' 
    current_swatch.classList.add('selected-swatch');
}


function showOOSForm(target){

    function updateOOSForm(form,target){

                    let buttons = Array.from(form.querySelectorAll('.esc-btn'));
                    const msg = {sms:"Thank you - we'll send you an SMS when your item becomes available",email:"Thank you - we'll send you an email when your item becomes available"}
                        
                    buttons.forEach(button => {
                                    const kind = button.dataset.alertType;
                                    
                        
                                                
                            const product_variant_id = target.dataset.variantId;
                                    


                        
                            button.addEventListener('click',function(e){
                                
                                            const input = document.querySelector(`input[name=${kind}]`);
                                            const destination = input.value;           

                                
                                            Array.from(document.querySelectorAll('.back-in-stock-warning')).forEach(warning => warning.remove());
                                            

                                            if(destination !== ""){
                                                    var xhr = new XMLHttpRequest;
                                                    xhr.open('POST', 'https://wigscom-ims.herokuapp.com/alerts', true);
                                                    xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded; charset=UTF-8');
                                                    xhr.send(   `alert%5Bproduct_variant_id%5D=${product_variant_id}&alert%5Bdestination%5D=${destination}&alert%5Bkind%5D=${kind}`) ;
                                                    const msg = {sms:"Thank you - we'll send you an SMS when your item becomes available",email:"Thank you - we'll send you an email when your item becomes available"}
                                                    let msg_elm = document.createElement('div');
                                                    msg_elm.innerHTML = `<span>${msg[kind]}</span>`;
                                                    e.currentTarget.remove();
                                
                                                    input.parentNode.replaceChild(msg_elm,input);
                                                
                                            }else{

                                                    let warning = document.createElement('div');
                                                    const warning_text = {sms:"Please enter a valid phone number",email:"Please enter a valid email address"}
                                                    warning.innerHTML = `<p class='back-in-stock-warning'><span> ${warning_text[kind]}</span></p>`;
                                                    input.parentNode.insertBefore(warning,input);


                                                
                                            }      
                                
                            });
                    
                    });

        return form;

                
    }
   
    
    let current_oos_form = document.querySelector('#esc-oos-form');
    if(current_oos_form){
        current_oos_form.remove();
    }

     let unavailable_ids = variant_groups.datasets.unavailable;
    
     if(unavailable_ids.includes( parseInt( target.dataset.variantId) ) ){
     
        let new_oos_form = document.querySelector('#oos-form-template').content.cloneNode(true);
        new_oos_form = updateOOSForm(new_oos_form,target);  
        
        variant_selector_wrapper.after(new_oos_form);
     }

}





function initSwatchDividers(){
    
    let swatch_container = document.querySelector('#swatch-container');

    
    
     const   group_settings = [{
            
            group_name:"new_colors",
            group_display_name:"New Colors",
            
        
            },
                          {
            
            group_name:"pre_launch",
            group_display_name:"Coming Soon!",
            
        
            },{
            
                group_name:"unavailable",
                group_display_name:"Back Soon!",
                
            
                }];

    group_settings.forEach(group_setting => {
        
            
        
            let figures = all_swatches.filter( swatch => variant_groups.datasets[group_setting.group_name].includes(parseInt( swatch.dataset.variantId) ) ).map(swatch => swatch.closest('figure'))
            if(figures.length > 0){
                let divider = `<figure>
                            
                            <div style="height:75px;width: 60px ;background-color:grey;color:white;text-align:center;font-size: 0.7rem;padding: 2px;border: 2px solid white;" id="${group_setting.group_name}-gallery-marker" class='gallery-separator'>   
                            
                            ${group_setting.group_display_name}
                            
                            
                            </div>
                        </figure>`;
                swatch_container.insertAdjacentHTML('beforeend',divider);
                figures.forEach(figure => swatch_container.append(figure));
            }    
        
        
    });

    
    
    
}



function initClearanceSection(){

        
            let clearance_message = clearance_percent_messaging.find(x => x.default === true);    
            let clearance_percent_discount_swatches = all_swatches.filter(swatch => variant_groups.datasets.clearance_percent_discount.includes( parseInt( swatch.dataset.variantId) ) );
        
            if(clearance_percent_discount_swatches.length > 0){
                  clearance_message = clearance_percent_messaging.find(x => x.percent_off === 25);           
            }
  
            let clearance_swatches = all_swatches.filter(swatch => variant_groups.datasets.on_clearance.includes( parseInt( swatch.dataset.variantId) ) );
            
            if(clearance_swatches.length > 0){
                let figures = clearance_swatches.map(c_swatch => c_swatch.closest('figure'));



                let swatch_container = document.querySelector('#swatch-container');
                swatch_container.insertAdjacentHTML('afterend',
                                                    `
                                                    <div class="clearance-div-divider"><br/></div>
                                                    <div class="clearance-container">
                                                    <span class="clearance-text">${clearance_message.message}</span>
                                                    <span id='clearance-swatch-pricing' class="clearance-price"> </span>
                                                    <span> Colors below!</span>
                                                    <div id="clearance-swatches">
                                                    </div>
                                                    </div>                                                  
                                                    `);

                figures.forEach(c_swatch  => document.querySelector('#clearance-swatches').append(c_swatch) );
            }

}

function createColorGroups(){
    
    const color_group_data = JSON.parse( document.querySelector('#color-group-data').textContent );
    const color_names =    Object.keys( color_group_data ).sort();
    
    
    color_names.forEach(color_name => {
        
            if(getVariantWith('color',color_name)){
                
                if(!color_groups.hasOwnProperty(color_group_data[color_name]))  color_groups[color_group_data[color_name]] = [];
                
            
                color_groups[color_group_data[color_name]].push(getVariantWith('color',color_name).id);
                
            }        
    
    })
    
    
    color_groups.favorites = variant_groups.datasets.best_sellers;
    color_groups.new_colors = variant_groups.datasets.new_colors;
    
    
    let color_groups_container=document.createDocumentFragment();
    let color_groups_list = document.createElement('ul');
     color_groups_list.id = 'color-groups';
    
    color_groups_display_order.forEach(order => {
    
        if( color_groups.hasOwnProperty(order) ){
            if(color_groups[order].length > 0){
            let li = document.createElement('li');
            let text = order.replace(/[-_]/g,' ');
            text = text[0].toUpperCase() + text.slice(1);
            let link = document.createElement('a');
            link.href="#";
            link.textContent = text;
            link.setAttribute('data-color-group',order);
            li.appendChild(link);
            color_groups_list.append(li);
            }
        }
    
        color_groups_container.append(color_groups_list);
        
    
    
        
        
    });
    if(color_groups_list.childElementCount > 0){

        color_groups_list.insertAdjacentHTML('afterbegin',`<li><a href="#" data-color-group="all">All</a></li>`);
        document.querySelector('#swatch-container').before(color_groups_container);
    }

    
}
    
function colorGroupHandler(target,event){
    
        
    event.preventDefault();

    let allGroupsLinks = document.querySelectorAll("#color-groups li a");
    
    allGroupsLinks.forEach((link) => {
        link.classList.remove("active");
    });

    target.classList.add("active");

    let color_group_name = target.dataset.colorGroup;

    let variants_in_group = []; 
    
    
    if(color_groups.hasOwnProperty(color_group_name)){
        
        variants_in_group = color_groups[color_group_name];
            
     }
    
    all_figures = Array.from( document.querySelectorAll('#swatch-container figure,#clearance-swatches figure'));
    all_figures.forEach(figure =>{ 
        
                
                figure.style ='display:inline-block'; 
                if(color_group_name == "all")return;
        
                swatch = figure.querySelector('img.swatch');
                if(!swatch){
                    figure.style ='display:none';
                    return;
                }    
        
        
            if( !variants_in_group.includes(parseInt( swatch.dataset.variantId ) ) ){
                    
                      figure.style ='display:none';
                    
            }
        
    });
    
    
}     
    
    
    
function hideShowClearanceSection(){

    let clearance_section = document.querySelector('#clearance-swatches');
    
    if(clearance_section){
            let figure_display_status =Array.from(  clearance_section.querySelectorAll('figure') ).map(figure => figure.style.display );
            
            if(figure_display_status.every(status => status === 'none')){
                clearance_section.style.visibility='hidden';
            }else{
                clearance_section.style.visibility='visible';
       }
    }


}

function addHTMLTo(selector=null,where='beforeend',new_HTML){

    
    selector = selector === '' ? null : selector;
        
    let element;
    
    if(selector){
    
        element = document.querySelector(selector);
    }
    
    if( element ){
        
        element.insertAdjacentHTML(where,new_HTML);
    }




}
function getPriceRangeString(prices){

    let unique_prices = [... new Set( prices ) ];
  
    if(unique_prices.length > 1 ){

          let unique_prices = [... new Set( prices ) ];
          let min = Math.min(... prices) / 100;
          let max = Math.max(... prices) /100;
          let price_range_string = formatter.format(min) + ` - ` + formatter.format(max);

        return price_range_string;
    }
   else{
      let price = Math.max(...prices) /100;
      
      return formatter.format(price);
    }
      
  
}

function displayMainPriceRange(){
  
    let selector = '.mainp-price .price__sale .price-item';
    let prices = meta.product.variants.map(x => x.price) ;
    let price_range_string = getPriceRangeString(prices);
    if(price_range_string){
        
    
            document.querySelector(selector).textContent = '';
        
        addHTMLTo(selector,'beforeend',`${price_range_string}`);
    }
}


function displayClearancePriceRange(){
  
    let selector = '#clearance-swatch-pricing';
    let prices = meta.product.variants.filter(variant => variant_groups.datasets.on_clearance.includes(variant.id)).map(v => v.price) ;
    if(prices.length > 1){
    let price_range_string = getPriceRangeString(prices);
      if(price_range_string){
          
      
              
          if(selector){
            document.querySelector(selector).textContent = price_range_string;
          }
      }
    }else if(prices.length == 1){
          
      document.querySelector(selector).textContent = formatter.format( prices[0] /100);
      
    }
}


function handleSlideChange(){
    
    // let current_slide = parseInt (document.querySelector('.slider-counter--current').textContent.trim() );
    
    // if( (current_slide !== 1  && !isNaN(current_slide) ) || !getURLParams('variant') ){
        
    //     disableATCButton();
        
    // }else{
        
    //     enableATCbutton()
    // }
    
    
}
function displaySelectedClearancePrice(target){
    let current_swatch = getCurrentSwatch(target);
    let [price=null] = meta.product.variants.filter(variant => variant.id === parseInt( current_swatch.dataset.variantId ) ).map(v => v.price);
    if(price){
          
        if( document.querySelector('#clearance-swatch-pricing') ){

                     document.querySelector('#clearance-swatch-pricing').textContent = formatter.format(price /100);
        }
    }
  

  
}





const initDropDownSelector = () => {

   let selector = document.querySelector('select[name="options[Color]"]');
   if(selector){
            selector.insertAdjacentHTML('afterbegin',`<option disabled selected>Choose a color</option>`);
    }


}

function handleClearanceLIP(target){
Array.from ( document.querySelectorAll('input.clearance_property')).forEach(lip => lip.remove());
let clearance_swatches = all_swatches.filter(swatch => variant_groups.datasets.on_clearance.includes( parseInt( swatch.dataset.variantId) ) );
let clearance_swatches_v_ids = clearance_swatches.map(cs => cs.dataset.variantId)
let current_swatch = getCurrentSwatch(target);
let variant_id =  current_swatch.dataset.variantId ;    
if(clearance_swatches_v_ids.includes( variant_id )){
    let form = document.querySelector('div.addtocart_wrapper form[action="/cart/add"]');
    form.insertAdjacentHTML('beforeend',`<input class="clearance_property" type="hidden" name="properties[_sale]" value="clearance">`);
    
}
}





//register event callbacks

elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id] ", callback: updateSelector});
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id] ", callback: highlightCurrentSwatch});    
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id] ", callback: updateATCButtonText});    
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id] ", callback: showOOSForm}); 
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback:handleClearanceLIP});
elements_to_callbacks.push({"event_type":"click","element_selector":"a[data-color-group]", callback:colorGroupHandler});
elements_to_callbacks.push({"event_type":"click","element_selector":"a[data-color-group]", callback:hideShowClearanceSection});

//elements_to_callbacks.push({"event_type":"click","element_selector":"#clearance-swatches img[data-variant-id]", callback:displaySelectedClearancePrice});


elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:highlightCurrentSwatch});
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:updateATCButtonText}); 
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:showOOSForm});
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:handleClearanceLIP});
//elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:displaySelectedClearancePrice});


elements_to_callbacks.push({"event_type":"slideChanged","element_selector":`slider-component`, callback:handleSlideChange});





//run on initial pageload 
initSwatchDividers();
initClearanceSection();
createColorGroups();




if(initial_swatch){
    highlightCurrentSwatch(initial_swatch);
    updateATCButtonText(initial_swatch);
    showOOSForm(initial_swatch);
    displayClearancePriceRange();
    //displaySelectedClearancePrice(initial_swatch);
    handleClearanceLIP(initial_swatch);
}else{

    //disable the cart button on initial load and update button only on those items with a 'choose a color' option
    if( document.querySelectorAll('.product-form__input.product-form__input--dropdown label')[0].innerText.toLowerCase()  === 'color' ){
      disableATCButton();      
      updateATCButtonText(initial_swatch,null,'Choose a color');  
    }
    
    
    // initDropDownSelector(); //turn on after removing the liquid code that does this.
    displayMainPriceRange();
    displayClearancePriceRange();

 
}


//}